<template>
  <div id="index">
    <my-header></my-header>
    <my-header2 style="display: none;"></my-header2>
    <my-banner></my-banner>
    <!-- index mian part -->
    <section id="index-main">
      <div class="container" v-if="categorys">
        <!-- focus and top news part -->
        <div class="row">
          <!-- focus part -->
          <div class="col-sm-6 col-lg-6 shadow mt-4" style="padding-left: 0; padding-right: 0;">
            <div id="carouselExampleIndicators3" class="carousel slide focus" data-ride="carousel" style="background-color: white;">
              <ol class="carousel-indicators">
                <li class="focus-li" data-target="#carouselExampleIndicators3" v-for="(item,index) in articles0" :key="item.id"  :data-slide-to="index" :class="{'active':index==0}"></li>
              </ol>
              <div class="carousel-inner" role="listbox">
                <div class="carousel-item" :class="{'active':index==0}" v-for="(item,index) in articles0" :key="item.id">
                  <!-- <a href="javascript:void(0)" @click="goArticleDetails(category1.pid,category1.id,item.id)"> -->
                  <a :href="detailUrl + item.id" :title="item.digest">
                    <img class="d-block mx-auto" v-bind:src="item.coverUrl" alt="" />
                    <div class="carousel-caption">
                      <h5></h5>
                      <p>{{item.title}}</p>
                    </div>
                  </a>
                </div>
              </div>
              <a class="carousel-control-prev" href="#carouselExampleIndicators3" role="button" data-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="sr-only">Previous</span>
              </a>
              <a class="carousel-control-next" href="#carouselExampleIndicators3" role="button" data-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="sr-only">Next</span>
              </a>
            </div>
          </div>
          <!-- top news part -->
          <div class="col-sm-6 col-lg-6 mt-4">
            <div class="container-fluid top-news">
              <ul id="clothingnav1" class="nav nav-tabs" role="tablist">
                <li class="nav-item"><a class="nav-link active" href="#home1" id="hometab1" role="tab" data-toggle="tab" aria-controls="news" aria-expanded="true"><!-- 校园动态 -->{{category1.name}}</a></li>
                <li class="nav-item"><a class="nav-link" href="#home2" id="hometab2" role="tab" data-toggle="tab" aria-controls="notes"><!-- 通知公告 -->{{category2.name}}</a></li>
              </ul>
              <!-- Content Panel -->
              <div id="clothingnavcontent1" class="tab-content">
                <div role="tabpanel" class="tab-pane fade show active" id="home1" aria-labelledby="hometab1">
                  <ul class="list-group">
                    <li class="list-group-item d-flex justify-content-between align-items-center" v-for="(item,index) in articles1.slice(5,14)" :key="item.id">
                      <a :href="detailUrl + item.id" :title="item.digest">{{item.title}}</a>
                      <span class="badge badge-pill">{{item.createTime!=null ? getPartTimeYmd(item.createTime) : item.createTime}}</span>
                    </li>
                  </ul>
                </div>
                <div role="tabpanel" class="tab-pane fade" id="home2" aria-labelledby="hometab2">
                  <ul class="list-group">
                    <li class="list-group-item d-flex justify-content-between align-items-center" v-for="(item,index) in articles2" :key="item.arId">
                      <a :href="detailUrl + item.id" :title="item.digest">{{item.title}}</a>
                      <span class="badge badge-pill">{{item.createTime!=null ? getPartTimeYmd(item.createTime) : item.createTime}}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 精品专业 -->
        <div class="major card-deck mt-4">
          <div class="card" v-for="citem in studentChildrens" :key="citem.id">
            <a :href="categoryUrl + citem.id">
              <img class="card-img-top" :src="citem.cover" :alt="citem.name">
              <!-- <div class="card-body">
                <h5 class="card-title">{{citem.name}}</h5>
                <p class="card-text"></p>
              </div> -->
            </a>
          </div>
        </div>
        <!-- ad banner part -->
        <div class="row my-3">
          <div class="col-md-12 col-lg-12 pl-0 pr-0"><a :href="adBanner.url"><img src="static/images/ad-banner/ad-baner.png" :src="adBanner.coverUrl" width="100%" height="100" /></a></div>
        </div>
        <!-- catalog list part -->
        <div class="row my-4">
          <!-- 教学科研 -->
          <div class="col-md-4 col-lg-4">
            <h3 class="list-hd">
              <!-- 教学科研 -->
              {{category5.name}}
              <a :href="categoryUrl + category5.id" class="float-right list-more">&nbsp;</a>
            </h3>
            <div class="list-line"></div>
            <div class="list-content" style="padding: 10px 0;">
              <ul class="list-group">
                <li class="list-group-item d-flex justify-content-between align-items-center" v-for="(item,index) in articles5" :key="item.id">
                  <a :href="detailUrl + item.id" :title="item.digest">{{item.title}}</a>
                  <span class="badge badge-pill">{{item.createTime!=null ? getPartTimeMd(item.createTime) : item.createTime}}</span>
                </li>
              </ul>
            </div>
          </div>
          <!-- 政策法规 -->
          <div class="col-md-4 col-lg-4">
            <h3 class="list-hd">
              <!-- 政策法规 -->
              {{category6.name}}
                <a :href="categoryUrl + category6.id" class="float-right list-more">&nbsp;</a>
              </h3>
              <div class="list-line"></div>
              <div class="list-content" style="padding: 10px 0;">
                <ul class="list-group">
                  <li class="list-group-item d-flex justify-content-between align-items-center" v-for="(item,index) in articles6" :key="item.id">
                    <a :href="detailUrl + item.id">{{item.title}}</a>
                    <span class="badge badge-pill">{{item.createTime!=null ? getPartTimeMd(item.createTime) : item.createTime}}</span>
                  </li>
                </ul>
              </div>
          </div>
          <!-- 党群工作 -->
          <div class="col-md-4 col-lg-4">
            <h3 class="list-hd">
              <!-- 党群工作 -->
              {{category7.name}}
                <a :href="categoryUrl + category7.id" class="float-right list-more">&nbsp;</a>
              </h3>
              <div class="list-line"></div>
              <div class="list-content" style="padding: 10px 0;">
                <ul class="list-group">
                  <li class="list-group-item d-flex justify-content-between align-items-center" v-for="(item,index) in articles7" :key="item.id">
                    <a :href="detailUrl + item.id">{{item.title}}</a>
                    <span class="badge badge-pill">{{item.createTime!=null ? getPartTimeMd(item.createTime) : item.createTime}}</span>
                  </li>
                </ul>
              </div>
          </div>
          <!-- end -->
        </div>

      </div>
    </section>
    <!-- marquee part -->
    <!-- <section class="marquee-part pt-5 pb-5">
      <div class="container">
        <div class="row">
          <div class="col-md-12 col-lg-12">
            <h3 class="list-hd text-white">{{category8.name}}</h3>
            <div class="list-line"></div>
            <div class="wrap container" id="myMarquee">
              <ul class="items list-unstyled row">
                <li class="item col-xs-4" v-for="(item,index) in articles8" :key="item.id">
                  <a :href="detailUrl + item.id">
                    <img class="img-responsive" :src="item.coverUrl" alt="" />
                    <span class="overflow-hidden">{{item.title}}</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section> -->
    <section class="show-section pt-5 pb-5">
      <div class="container">
        <div class="show-hd text-center text-white" v-if="category9">
          {{category9.name}}
        </div>
        <div class="card-deck mt-5">
          <div class="card" v-for="(item,index) in articles9.slice(0,4)" :key="item.id">
            <a :href="detailUrl + item.id">
              <img class="card-img-top" :src="item.coverUrl" alt="">
              <div class="card-body">
                <h5 class="card-title">{{item.title}}</h5>
              </div>
            </a>
          </div>
        </div>
        <div class="card-deck mt-3">
          <div class="card" v-for="(item,index) in articles9.slice(4)" :key="item.id">
            <a :href="detailUrl + item.id">
              <img class="card-img-top" :src="item.coverUrl" alt="">
              <div class="card-body">
                <h5 class="card-title">{{item.title}}</h5>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
    <!-- friendlink part -->
    <section class="friend-link">
      <div class="container">
        <div class="row my-4 d-none d-md-block">
          <div class="col-md-12 col-lg-12">
            <h3 class="list-hd">友情链接</h3>
            <div class="list-line"></div>
            <div class="row text-center friendlink">
              <div class="col-sm-2 col-12 p-2" v-for="item in friendlink" :key="item.id"><a :href="item.url"><img class="img-thumbnail" :src="item.coverUrl" alt="" /></a></div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- back-to-top -->
    <!-- <div class="back-to-top gotop" @click="goScrollTop()">TOP</div> -->
    <!-- <a href="#top" class="back-to-top"> Back to top </a> -->
    <!-- <a id="back-to-top" href="" class="btn btn-primary btn-lg back-to-top" role="button" title="Click to return on the top page" data-toggle="tooltip" data-placement="left">
      <span class="glyphicon glyphicon-chevron-up"></span>
    </a> -->
    <!-- footer part -->
    <my-footer></my-footer>
  </div>
</template>

<script>
  import header from '@/views/header/header'
  import banner from '@/views/banner/banner'
  import footer from '@/views/footer/footer'
  import header2 from '@/views/header/header2'

  const axios = require('axios')

  export default {
    name: 'index',
    components: {
      'my-header': header,
      'my-banner': banner,
      'my-footer': footer,
      'my-header2': header2,
    },
    data () {
      return {
        articles: null,
        articles0: [{}],
        articles1: [{}],
        articles2: [{}],
        articles3: [{}],
        articles4: [{}],
        articles5: [{}],
        articles6: [{}],
        articles7: [{}],
        articles8: [{}],
        articles9: [{}],
        articlesSjkt: null,
        categorys: null,
        category1: null,
        category2: null,
        category3: null,
        category4: null,
        category5: null,
        category6: null,
        category7: null,
        category8: null,
        category9: null,
        studentChildrens: null,
        detailUrl: '/article/details/',
        categoryUrl: '/article/category/',
        adBanner: [{}],
        friendlink: [{}],
        istop: true
      }
    },
    mounted () {
      let that = this
      // 首页栏目列表
      axios.get(that.global.apiUrl + '/web/channel/listAll')
        .then(function (response) {
          if (response.data.success && response.data.data.length > 0) {
            that.categorys = response.data.data
            // console.log(that.categorys)
            that.$nextTick(function () {

            })

            for (var index in that.categorys) {
              // 新闻动态
              if (that.categorys[index].code == 'news') {
                for (var n in that.categorys[index].children) {
                  // 校园新闻
                  if (that.categorys[index].children[n].code == 'schoolnews') {
                    that.category1 = that.categorys[index].children[n]
                  }
                  // 通知公告
                  if (that.categorys[index].children[n].code == 'notice') {
                    that.category2 = that.categorys[index].children[n]
                  }
                }
              }

              // 精品专业
              if (that.categorys[index].code == 'major') {
                that.category3 = that.categorys[index]
                that.studentChildrens = that.categorys[index].children
                for (var i in that.studentChildrens) {
                  const item = that.studentChildrens[i]
                  item.cover = that.global.apiUrl + '/file/getImgStream?idFile=' + item.img
                }
              }

              //
              if (that.categorys[index].code == 'teacher') {
                for (var n in that.categorys[index].children) {
                  // 实景课堂
                  // if(that.categorys[index].children[n].code == 'jxky') {
                  //   that.category4 = that.categorys[index].children[n]
                  // }

                  // 教学科研
                  if (that.categorys[index].children[n].code == 'jxky') {
                    that.category5 = that.categorys[index].children[n]
                  }
                }
              }

              // 菁菁校园
              if (that.categorys[index].code == 'student') {
                for (var n in that.categorys[index].children) {
                  // 社团活动
                  if (that.categorys[index].children[n].code == 'stusthd') {
                    that.category6 = that.categorys[index].children[n]
                  }
                  // 优秀毕业生
                  if (that.categorys[index].children[n].code == 'stuyxbys') {
                    that.category8 = that.categorys[index].children[n]
                  }
                  // 图说校园
                  if (that.categorys[index].children[n].code == 'stutsxy') {
                    that.category9 = that.categorys[index].children[n]
                  }
                }
              }


              // 党建工作
              if (that.categorys[index].code == 'party') {
                for (var n in that.categorys[index].children) {
                  // 党建园地
                  if (that.categorys[index].children[n].code == 'partynews') {
                    that.category7 = that.categorys[index].children[n]
                  }
                }
              }

            }

            // console.log(that.category1)
            // 校园动态
            axios.get(that.global.apiUrl + '/web/article/list?page=1&limit=5&idChannel=' + that.category1.id + '&sort=id&order=desc')
              .then(function (response) {
                // console.log(response.data.data.records)
                if (response.data.success && response.data.data.records.length > 0) {
                  that.articles0 = response.data.data.records
                  for (var index in that.articles0) {
                    const item = that.articles0[index]
                    item.digest = item.title
                    item.title = item.title.length > 36 ? item.title.substring(0, 36) + '...' : item.title
                    item.coverUrl = that.global.apiUrl + '/file/getImgStream?idFile=' + item.img
                  }
                }
              })
            axios.get(that.global.apiUrl + '/web/article/list?page=1&limit=14&idChannel=' + that.category1.id + '&sort=id&order=desc')
              .then(function (response) {
                // console.log(response.data.data.records)
                if (response.data.success && response.data.data.records.length > 0) {
                  that.articles1 = response.data.data.records
                  for (var index in that.articles1) {
                    const item = that.articles1[index]
                    item.digest = item.title
                    item.title = item.title.length > 28 ? item.title.substring(0, 28) + '...' : item.title
                  }
                }
              })

            // 通知公告
            axios.get(that.global.apiUrl + '/web/article/list?page=1&limit=9&idChannel=' + that.category2.id + '&sort=id&order=desc')
              .then(function (response) {
                if (response.data.success && response.data.data.records.length > 0) {
                  that.articles2 = response.data.data.records
                  for (var index in that.articles2) {
                    const item = that.articles2[index]
                    item.digest = item.title
                    item.title = item.title.length > 28 ? item.title.substring(0, 28) + '...' : item.title
                  }
                  // 设置tab为鼠标悬停切换
                  // $("#clothingnav1 a").mousemove(function (e) {
                  //         $(this).tab('show');
                  //  });
                }
              })

            // 教学科研
            axios.get(that.global.apiUrl + '/web/article/list?page=1&limit=8&idChannel=' + that.category5.id + '&sort=id&order=desc')
              .then(function (response) {
                if (response.data.success && response.data.data.records.length > 0) {
                  that.articles5 = response.data.data.records
                  for (var index in that.articles5) {
                    const item = that.articles5[index]
                    item.digest = item.title
                    item.title = item.title.length > 19 ? item.title.substring(0, 18) + '...' : item.title
                  }
                }
              })

            // 社团活动
            axios.get(that.global.apiUrl + '/web/article/list?page=1&limit=8&idChannel=' + that.category6.id + '&sort=id&order=desc')
              .then(function (response) {
                if (response.data.success && response.data.data.records.length > 0) {
                  that.articles6 = response.data.data.records
                  for (var index in that.articles6) {
                    const item = that.articles6[index]
                    item.digest = item.title
                    item.title = item.title.length > 19 ? item.title.substring(0, 18) + '...' : item.title
                  }
                }
              })

            // 党建园地
            axios.get(that.global.apiUrl + '/web/article/list?page=1&limit=8&idChannel=' + that.category7.id + '&sort=id&order=desc')
              .then(function (response) {
                if (response.data.success && response.data.data.records.length > 0) {
                  that.articles7 = response.data.data.records
                  for (var index in that.articles7) {
                    const item = that.articles7[index]
                    item.digest = item.title
                    item.title = item.title.length > 19 ? item.title.substring(0, 18) + '...' : item.title
                  }
                }
              })

            // 图说校园
            axios.get(that.global.apiUrl + '/web/article/list?page=1&limit=8&idChannel=' + that.category9.id + '&sort=id&order=desc')
              .then(function (response) {
                if (response.data.success && response.data.data.records.length > 0) {
                  that.articles9 = response.data.data.records
                  for (var index in that.articles9) {
                    const item = that.articles9[index]
                    item.digest = item.title
                    item.title = item.title.length > 30 ? item.title.substring(0, 30) + '...' : item.title
                    item.coverUrl = that.global.apiUrl + '/file/getImgStream?idFile=' + item.img
                  }
                }
              })

            // 优秀毕业生
            axios.get(that.global.apiUrl + '/web/article/list?page=1&limit=9&idChannel=' + that.category8.id + '&sort=id&order=desc')
              .then(function (response) {
                if (response.data.success && response.data.data.records.length > 0) {
                  that.articles8 = response.data.data.records
                  for (var index in that.articles8) {
                    const item = that.articles8[index]
                    item.coverUrl = that.global.apiUrl + '/file/getImgStream?idFile=' + item.img
                  }
                  that.$nextTick(function () {
                    // 设置marquee
                    var box = $('#myMarquee'),
                      v = 1.5 // 这里添加滚动的对象和其速率
                    Rin(box, v)

                    function Rin ($Box, v) {
                      // $Box移动的对象，v对象移动的速率
                      var $Box_ul = $Box.find('ul'),
                        $Box_li = $Box_ul.find('li'),
                        $Box_li_span = $Box_li.find('span'),
                        left = 0,
                        s = 0,
                        timer // 定时器

                      $Box_li.each(function (index) {
                        $($Box_li_span[index]).width($(this).width()) // hover
                        s += $(this).outerWidth(true) // 即要滚动的长度
                      })

                      window.requestAnimationFrame =
                        window.requestAnimationFrame ||
                        function (Tmove) {
                          return setTimeout(Tmove, 1000 / 60)
                        }
                      window.cancelAnimationFrame = window.cancelAnimationFrame || clearTimeout

                      if (s >= $Box.width()) {
                        // 如果滚动长度超出Box长度即开始滚动，没有的话就不执行滚动
                        $Box_li.clone(true).appendTo($Box_ul)
                        Tmove()
                        function Tmove () {
                          // 运动是移动left  从0到-s;（个人习惯往左滚）
                          left -= v
                          if (left <= -s) {
                            left = 0
                            $Box_ul.css('left', left)
                          } else {
                            $Box_ul.css('left', left)
                          }
                          timer = requestAnimationFrame(Tmove)
                        }
                        $Box_ul.hover(
                          function () {
                            cancelAnimationFrame(timer)
                          },
                          function () {
                            Tmove()
                          }
                        )
                      }
                    }
                  })
                }
              })
          }
        })

      // 获取adBanner
      this.getAdBanner()
      // 获取友情链接
      this.getFriendlink()
      // 监听滚动条
      window.addEventListener('scroll', this.getScroll);
    },
    methods: {
      getAdBanner: function () {
        var that = this
        axios.get(that.global.apiUrl + '/web/banner/queryAllByType?type=indexad')
          .then(function (response) {
            if (response.data.success && response.data.data.length > 0) {
              that.adBanner = response.data.data[0]
              that.adBanner.coverUrl = that.global.apiUrl + '/file/getImgStream?idFile=' + that.adBanner.idFile
            }
          })
      },

      getFriendlink: function () {
        var that = this
        axios.get(that.global.apiUrl + '/web/friendlink/queryAll')
          .then(function (response) {
            if (response.data.success && response.data.data.length > 0) {
              that.friendlink = response.data.data
              for (var index in that.friendlink) {
                const item = that.friendlink[index]
                item.coverUrl = that.global.apiUrl + '/file/getImgStream?idFile=' + that.friendlink[index].img
              }
            }
          })
      },

      getPartTimeForDate: function (timestamp) {
        // var timearr = val.replace(" ", ":").replace(/\:/g, "-").split("-");
        // var timestr = ""+ Number(timearr[1])+ "月" + timearr[2]+"日";
        // return timestr;
        var date = new Date(timestamp)// 时间戳为10位需*1000，时间戳为13位的话不需乘1000
        Y = date.getFullYear() + '-'
        M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
        D = date.getDate() + ' '
        h = date.getHours() + ':'
        m = date.getMinutes() + ':'
        s = date.getSeconds()
        return Y + M + D
      },
      getPartTimeYmd: function (val) {
        // let ti = val.split(' ');
        var timearr = val.split(' ')
        var timestr = '' + timearr[0]
        return timestr
      },
      getPartTimeMd: function (val) {
        // var timearr = val.replace(" ", ":").replace(/\:/g, "-").split("-");
        // var timestr = ""+ Number(timearr[1])+ "月" + timearr[2]+"日";
        // console.log(val);
        var date = new Date(val)
        var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
        var D = date.getDate() + ' '
        // console.log(date);
        var timestr = M + D
        return timestr
      },

      //监听滚动
      getScroll() {
        let that = this
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        // console.log(scrollTop)
        var offsetTop = document.querySelector('#my-header').offsetTop
        // if (scrollTop > offsetTop) {
        //   document.getElementById('my-header').style.display = 'none'
        //   document.getElementById('my-header2').style.position = 'fixed'
        //   document.getElementById('my-header2').style.display = 'block'
        // } else {
        //   document.getElementById('my-header2').style.display = 'none'
        //   document.getElementById('my-header').style.display = 'block'
        // }
        // this.indexNumTop = $("#my-header").offset().top;
        // this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        // if (!!document.documentElement.scrollTop&&document.documentElement.scrollTop == 120){
        //   if(that.istop) {
        //     console.log('aaaa')
        //     that.istop = false
        //     document.getElementById('my-header').style.display = 'none'
        //     // document.getElementById('banner').style.marginTop = '117px'
        //     document.getElementById('my-header2').style.position = 'fixed'
        //     document.getElementById('my-header2').style.display = 'block'
        //   }
        // } else {
        //   that.istop = true
        //   document.getElementById('my-header2').style.display = 'none'
        //   document.getElementById('banner').style.marginTop = '0'
        //   document.getElementById('my-header').style.display = 'block'
        // }
      },
      // 返回顶部
      // ScrollTop() {
      //   window.scrollBy(0, -100);
      // },
      // goScrollTop() {
      //   document.documentElement.scrollTop = 0;
      //   // scroll(0,-100)
      //   //把内容滚动指定的像素数（第一个参数是向右滚动的像素数，第二个参数是向下滚动的像素数）
      //   //向上是负数，向下是正数
      //   // console.log('sssss')
      //   // window.scrollBy(0, 0);
      //   // //延时递归调用，模拟滚动向上效果
      //   // // scrolldelay = setTimeout( this.ScrollTop() , 100);
      //   // //获取scrollTop值，声明了DTD的标准网页取document.documentElement.scrollTop，否则取document.body.scrollTop；因为二者只有一个会生效，另一个就恒为0，所以取和值可以得到网页的真正的scrollTop值
      //   // var  sTop = document.documentElement.scrollTop + document.body.scrollTop;
      //   // //判断当页面到达顶部，取消延时代码（否则页面滚动到顶部会无法再向下正常浏览页面）
      //   // if(sTop == 0){
      //   //   clearTimeout(scrolldelay);
      //   // }
      // }

    }
  }
</script>

<style>
  .row {
    margin-left: 0;
    margin-right: 0;
  }
  .badge-pill {
    color: #808080;
    font-weight: normal;
  }
  a {
    color: #333333;
  }
  a:hover {
    color: #333333;
  }
  #index-main {
    margin: 0;
  }
  .focus {
    height: 350px;
  }
  .focus .carousel-inner {
    height: 350px;
  }
  .focus .carousel-item {
    height: 350px;
  }
  .focus .carousel-item img {
    height: 350px;
    width: 100%;
  }
  .top-news {
    height: 350px;
    font-size: 14px;
  }
  .top-news .list-group-item {
    height: 35px;
    border: 0;
    border-bottom: 1px #dee2e6 dotted;
    background: url(/static/img/icons/icon-list.png) no-repeat left center;
    padding: 0 0 0 15px;
  }
  .top-news .list-group-item a {
    color: #333;
  }
  .top-news .tab-content ul {
    /* border: 1px #dee2e6 solid; */
    border-top: 0;
  }
  .list-hd {
    font-size: 16px;
    font-weight: bold;
  }
  .list-more {
    width: 20px;
    height: 20px;
    background: url(/static/img/icons/icon-more.png) no-repeat center center;
  }
  .list-line {
    height: 3px;
    /* background: linear-gradient(to right,#bb0439,#8B0000); */
    background: linear-gradient(to bottom,#2092c8,#235e88);
  }
  .list-content {
    padding: 10px;
  }
  .list-content img {
    border: 0;
    width: 100%;
    height: 100%;
  }
  .list-content .list-group-item {
    font-size: 14px;
    height: 35px;
    border: 0;
    border-bottom: 1px #dee2e6 dotted;
    background: url(/static/img/icons/icon-list.png) no-repeat left center;
    padding: 0 0 0 15px;
  }
  .list-content .list-group-item a {
    color: #333;
  }
  .list-content .tab-content ul {
    /* border: 1px #dee2e6 solid; */
    border-top: 0;
  }
  .friendlink img {
    width: 100%;
    height: 100%;
    transition: all 0.5s ease;
  }
  .friendlink img:hover {
    transform: scale(1.1);
  }

  .list-more:hover {
    text-decoration: none;
  }
  .carousel-caption {
    left: 0!important;
    right: 0!important;
    background-color: rgba(0,0,0,0.5);
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .carousel-caption p {
    margin-bottom: 0.5rem;
    width: 100%;

  }
  .focus-li {
    width: 8px!important;
    height: 8px!important;
    border-radius: 50%;
  }
  .show-section {
    /* background: url(/static/img/bg/mode04_bg.png) no-repeat; */
    background: url(/static/img/bg/bg-2.png) no-repeat;
    background-size: cover;
  }
  .show-section .card-deck .card {
    overflow: hidden;
  }
  .show-section .card-deck .card-img-top {
    height: 10rem;
  }
  .show-section .card-deck .card-title {
    font-size: 14px;
    font-weight: bold;
  }
  .show-section .card-deck a:hover {
    text-decoration: none;
  }
  .show-section .card-deck a img {
    transition: all 0.5s ease;
  }
  .show-section .card-deck a:hover img {
    transform: scale(1.2);
  }
  .show-section .show-hd {
    font-size: 30px;
    font-weight: bold;
  }
  .show-section .card-body {
    padding-bottom: 0;
  }
  /* 精品专业 */
  .major .card {
    border: 0;
  }
  .major .card img {
     /* transition: all 0.5s ease; */
     border-radius: 5px;
  }
  .major .card img:hover {
    animation: imgRotate 0.5s ease;
  }
  @keyframes imgRotate {
    0% {
      transform: rotate(5deg);
    }
     25% {
      transform: rotate(0deg);
    }
    50% {
      transform: rotate(-5deg);
    }
    100% {
      transform: rotate(0);
    }
  }
@keyframes imgscale {
  /*0% {
    transform: scale(1);
  }
   25% {
    transform: scale(1.1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1.2);
  }*/
  from {
    transform: scale(1);
  }
  to {
    transform: scale(1.2);
  }
}

@-webkit-keyframes imgscale /*Safari and Chrome*/ {
  0% {
    transform: scale(1); /*开始为原始大小*/
  }
  /* 25% {
    transform: scale(1.1);
  }
  50% {
    transform: scale(1.1);
  }
  75% {
    transform: scale(1.2);
  } */
  100% {
    transform: scale(1.2);
  }
}
  /* marquee区域样式 */
  .marquee-part {
    background: url(/static/img/bg/mode04_bg.png) no-repeat;
  }
  #myMarquee {
    width: 100%;
    height: 216px;
    overflow: hidden;
    position: relative;
  }
  .items {
    white-space: nowrap;
    margin-bottom: 0;
    overflow: hidden;
    width: 10000px;
    height: 216px;
    padding: 10px 0;
    position: absolute;
    left: 0;
  }
  .item {
    width: 286px;
    height: 196px;
    margin-right: 10px;
    display: inline-block;
    padding: 2px;
    float: left;
    border: 1px #ccc solid;
    position: relative;
  }

  .img-responsive {
    width: 280px;
    height: 190px;
  }

  .item a span {
    height: 0;
    display: block;
    background: rgba(0, 0, 0, 0.4);
    position: absolute;
    bottom: 2px;
    color: #fff;
    font-size: 0px;
  }
  .item a:hover span {
    height: 190px;
    line-height: 190px;
    font-size: 20px;
    text-align: center;
    transition: all 0.7s;
  }

  .col-lg-2 {
    -ms-flex: 0 0 20%;
    -webkit-box-flex: 0;
    flex: 0 0 20%;
    max-width: 20%;
    padding: 20px 0 0;
  }
  .card-columns {
    column-count: 4;
  }
  /* .gotop {
    position: fixed;
    bottom: 40px;
    right: 20px;
    z-index: 9999999;
    color: #fff;
    text-align: center;
    font-size: 14px;
    transition: none;
    background-color: #000;
    width: 50px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    cursor: pointer;
  } */
</style>



// WEBPACK FOOTER //
// src/views/index/index.vue